import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import { Button } from "@mui/material";
import { Close } from "@mui/icons-material";
import CancellationHistoryTable from "./CancellationHistoryTable";

interface CancellationHistoryDialogProps {
  open: boolean;
  onClose: () => void;
  patientId: number;
}

/**
 * Popup that shows the full cancellation history (resolved and unresolved) for a
 * patient as a table, making it explicit who initiated each cancellation and
 * what the relevant metadata (timeliness, call status, invoicing) was.
 */
export default function CancellationHistoryDialog({
  open,
  onClose,
  patientId,
}: CancellationHistoryDialogProps) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        Stornierungsverlauf
        <IconButton onClick={onClose} aria-label="Schließen" size="small">
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        {/* Only fetch while the dialog is open. */}
        <CancellationHistoryTable patientId={patientId} enabled={open} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Schließen</Button>
      </DialogActions>
    </Dialog>
  );
}
